/**
 * Opens a already added filter-object in a up-modal
 * So you can edit the filter built for the query-builder
 *
 * @param  {object} filterObj The filter object to modify
 */

import FilterService from 'App/services/FilterService';

angular.module('upListFilter.controllers').service('FilterService', function () {
	return FilterService;
});
